import { render, staticRenderFns } from "./PageCommunity.vue?vue&type=template&id=0de0df86&scoped=true"
import script from "./PageCommunity.vue?vue&type=script&lang=js"
export * from "./PageCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de0df86",
  null
  
)

export default component.exports